import React from 'react';
import PropTypes from "prop-types";
import { StyledStatusCircle } from './styled';

const StatusCircle = ({ variant, size, value, customStyle }) => {
    return (
        <StyledStatusCircle
            variant={variant}
            size={size}
            value={value}
            customStyle={customStyle}
        />
    );
};

StatusCircle.propTypes = {
    variant: PropTypes.oneOf(['absolute', 'relative']),
    size: PropTypes.oneOf(['small', 'medium']),
    value: PropTypes.number,
    customStyle: PropTypes.array
};

StatusCircle.defaultProps = {
    variant: 'relative',
    size: 'medium',
    value: 0
};

export default React.memo(StatusCircle);
